import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Loading.css';

class Loading extends Component {
  render() {
    if (!this.props.show) {
      return <span />;
    }
    const size = this.props.size;
    const ste = this.props.style;
    if (size > 0) {
      ste.fontSize = size;
    }
    let loading = (
      <div className="svg-loader" style={ste}>
        <svg width="1em" height="1em">
          <circle style={{ stroke: this.props.color }} cx="0.5em" cy="0.5em" r="0.45em" />
        </svg>
      </div>
    );

    if (this.props.children) {
      loading = this.props.children;
    }

    if (this.props.display === 'inline') {
      return loading;
    }

    return (
      <div className="react-loading-spinner">
        <div className="loading-inner">
          {loading}
          <div className="alert-text">{this.props.text}</div>
        </div>
      </div>
    );
  }
}

Loading.propTypes = {
  type: PropTypes.string,
  display: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
  text: PropTypes.string,
  cls: PropTypes.string,
  show: PropTypes.bool,
};

Loading.defaultProps = {
  type: 'svg',
  style: {},
  color: '#9b59b6',
  text: 'Loading...',
  cls: '',
  show: false,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/index.js